<template>
    <v-flex column>
        <v-card class="logoutCard" elevation="24">
            <v-progress-linear rounded
                               height="6"
                               :active="spLoggingOut"
                               :indeterminate="spLoggingOut">
            </v-progress-linear>
            <v-alert id="errorMessage"
                     v-model="error"
                     dismissible
                     type="error"
                     transition="slide-x-reverse-transition">
                {{ errorMessage }}
            </v-alert>
            <div v-if="loggedOut && spLoggingOut" class="returnMessage">
                <v-card-title id="loggingOutMessage" class="text-xs-center">We are logging you out...</v-card-title>
                <v-card-text class="text-xs-center">Please don't close this window.</v-card-text>
                <iframe hidden="hidden" v-if="signOutIframeUrl" :src="signOutIframeUrl"></iframe>
            </div>
            <div v-else-if="loggedOut && !spLoggingOut">
                <v-card-title id="logoutConfirmationMessage" class="text-xs-center"> {{samlLogoutUrl ? "Redirecting you to logout of your organziation" : "You are now logged out."}}</v-card-title>
                <v-card-text class="text-xs-center" v-if="samlLogoutUrl">
                  If you are not automatically redirected please click <a id="samlLogoutUrl" :href="samlLogoutUrl">here</a>.
                </v-card-text>
              <v-card-text class="text-xs-center" v-else-if="postLogoutRedirectUri">
                Click <a id="postLogoutRedirectUri" :href="postLogoutRedirectUri">here</a> to return to the
                <em>{{clientName}}</em> application.
              </v-card-text>
              <v-card-text class="text-xs-center" v-else>You may now close the window.</v-card-text>
            </div>
            <v-form v-else @submit.prevent="logout">
                <div class="text-xs-center mt-2 mb-3">
                    <v-flex>
                        <v-card-title id="logoutMessage">Ready to log out?</v-card-title>
                    </v-flex>
                </div>
                <v-layout justify-center>
                    <v-flex xs8>
                        <v-card-actions>
                            <v-btn block id="signOut" type="submit" class="font-weight-bold">
                                Yes
                            </v-btn>
                        </v-card-actions>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>
    </v-flex>
</template>

<script>
    import { mapState } from 'vuex';
    import store from '../store';

    export default {
        name: 'logout',

        props: ['initialLoggedOut', 'logoutId', 'initialPostLogoutRedirectUri', 'initialSignOutIframeUrl', 'initialClientName', "samlLogoutUrl"],

        data() {
            return {
                error: false,
                errorMessage: '',
                postLogoutRedirectUri: this.initialPostLogoutRedirectUri,
                signOutIframeUrl: this.initialSignOutIframeUrl,
                clientName: this.initialClientName,
                loggedOut: this.initialLoggedOut,
                samlLogoutUrl: this.samlLogoutUrl
            }
        },

        computed: mapState({
            spLoggingOut: state => state.logout.spLoggingOut
        }),

            methods: {
        async logout() {
            const OLD_API_URL = window.APP_CONFIG.identityApi_OldUrls;
            const NEW_API_URL = window.APP_CONFIG.identityApi_NewUrls;
            const OLD_API_HOST = OLD_API_URL ? new URL(OLD_API_URL).hostname : null;
            const NEW_API_HOST = NEW_API_URL ? new URL(NEW_API_URL).hostname : null;
            const currentUrlHost = window.location.hostname;
            let otherApiUrl = null;

            if (currentUrlHost === OLD_API_HOST) {
                otherApiUrl = NEW_API_URL;
            }
            else if (currentUrlHost === NEW_API_HOST) {
                otherApiUrl = OLD_API_URL;
            }
            const crossLogoutDone = String(this.$route.query.crossLogoutDone).toLowerCase() === 'true';
            const backToApiDone = String(this.$route.query.backToApiDone).toLowerCase() === 'true';
            if (otherApiUrl && !crossLogoutDone && !backToApiDone) {
                const redirectUrl =`${otherApiUrl}/auth/logout?logoutId=${this.logoutId}&showLogoutPrompt=False&crossLogoutDone=True`;
                
                console.log('[Logout Component] STEP 1: Redirecting to other API');
                console.log('[Logout Component] Redirect URL:', redirectUrl);
                window.location.href = redirectUrl;

                console.log('[Logout Component] window.location.href assigned');
                
                return;
            }

            console.log('[Logout Component] STEP 1 skipped - already on correct logout stage');

            try {
                console.log('[Logout Component] STEP 2: Calling logout API');

                // Logout current API and WAIT for it to finish
                const response = await this.$identityApi.logout.post({
                    payload: {
                        LogoutId: this.logoutId
                    }
                });

                console.log('[Logout Component] Logout API completed successfully');
                console.log('[Logout Component] Response:', response);
                console.log('[Logout Component] Response data:',response.data);

                // Current API logout has completed here
                store.commit("logout/spLoggedOut", true);

                this.clientName = response.data.clientName;
                this.signOutIframeUrl = response.data.signOutIframeUrl;
                this.postLogoutRedirectUri =
                    response.data.postLogoutRedirectUri;

                this.loggedOut = true;

                // Normal final redirect
                if (this.samlLogoutUrl) {
                    setTimeout(() => {
                        window.location = this.samlLogoutUrl;
                    }, 5000);
                } else if (response.data.postLogoutRedirectUri) {
                    setTimeout(() => {
                        window.location = response.data.postLogoutRedirectUri;
                    }, 5000);
                }

                setTimeout(() => {
                    store.commit("logout/spLoggedOut", false);
                }, 5000);

                } catch (error) {
                    store.commit("logout/spLoggedOut", false);
                    this.error = true;
                    this.errorMessage = "There was an error logging out.";
            }
            
            if (otherApiUrl && crossLogoutDone && !backToApiDone) {
                const redirectUrl =`${otherApiUrl}/auth/logout?logoutId=${this.logoutId}&showLogoutPrompt=False&crossLogoutDone=True&backToApiDone=True`;
                
                console.log('[Logout Component] STEP 4: Redirecting to other API');
                console.log('[Logout Component] Redirect URL:', redirectUrl);
                window.location.href = redirectUrl;

                console.log('[Logout Component] window.location.href assigned');
                return;
            }
        }
    }
}
</script>
